import * as React from "react";
import { TimedChangbleFrame } from "../../../../components";
const betFinishedClass = "rj-my-pulse-bets__bet-finished-frame";
export class BetFinishedFrame extends React.Component {
    render() {
        let viewData = [];
        /*istanbul ignore next */
        if (this.props.won) {
            /*istanbul ignore next */
            viewData.push({
                childrenData: { timeOutMili: 2000 },
                element: React.createElement("div", { className: `${betFinishedClass} ${betFinishedClass}--container` },
                    React.createElement("div", { className: `${betFinishedClass}-message ${betFinishedClass}-message-goal` }, this.props.goMsg))
            });
            /*istanbul ignore next */
            viewData.push({
                childrenData: {
                    timeOutMili: 3800,
                    /* istanbul ignore next */
                    timedOutHandler: () => this.setState({ previewFinished: true })
                },
                element: React.createElement("div", { className: `${betFinishedClass} ${betFinishedClass}--container` },
                    React.createElement("div", { className: `${betFinishedClass}-message ${betFinishedClass}-message-win` }, this.props.winMsg))
            });
        }
        /* istanbul ignore next */
        viewData.push({
            childrenData: { timeOutMili: 5000, timedOutHandler: () => this.props.removeBetHandler() },
            element: React.createElement("div", { className: `${betFinishedClass} ${betFinishedClass}--try-again-wrapper` })
        });
        return (React.createElement(TimedChangbleFrame, { key: "2", childrenData: viewData.map((d) => d.childrenData) }, viewData.map((d, index) => React.createElement(React.Fragment, { key: index }, d.element))));
    }
}
//# sourceMappingURL=BetFinishedFrame.js.map